export default __webpack_public_path__ + "static/media/applestore.2ca6ec76.png";